import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import CheckAlsoProject from './CheckAlsoProject';
import CheckAlsoPage from './CheckAlsoPage';
import CheckAlsoTags from './CheckAlsoTags';

const CheckAlso = ({ pages, projects }) => {
  const hasPages = !!pages.length;
  const hasProjects = !!projects.length;
  if (!hasPages && !hasProjects) {
    return null;
  }
  return (
    <>
      <Row>
        <Col xs={12}>
          <h3 className="checkAlso-header pb-4">Sprawdź także</h3>
        </Col>
      </Row>
      {hasProjects && (
        <>
          <Row>
            <Col xs={12}>
              <h5 className="main-header checkAlso-projects-header">
                <span>Projekty</span> szkolne
              </h5>
            </Col>
          </Row>
          {projects.map((project, idx) => (
            <CheckAlsoProject key={idx} data={project} />
          ))}
        </>
      )}
      {hasPages && (
        <Row>
          <Col xs={12}>
            <h5 className="main-header checkAlso-pages-header">
              <span>Ciekawe</span> strony
            </h5>
          </Col>
          <Col xs={12} md={6}>
            <Row>
              {pages.map((page, idx) => (
                <CheckAlsoPage key={idx} data={page} />
              ))}
            </Row>
          </Col>
        </Row>
      )}
      {/*
      <Row>
        <Col xs={12}>
          <h5 className="main-header checkAlso-tags-header">
            <span>Powiązane</span> kategorie
          </h5>
        </Col>
        <Col xs={12}>
          <CheckAlsoTags />
        </Col>
      </Row>
      */}
    </>
  );
};

CheckAlso.propTypes = {
  pages: PropTypes.array,
  projects: PropTypes.array
};

export default CheckAlso;
